export const METHOD_OPTIONS = [
    { id: 1, name: 'get' },
    { id: 2, name: 'post' },
    { id: 3, name: 'put' },
    { id: 4, name: 'delete' },
]
